import axios from 'axios';
import { html } from 'rune-ts';
import { iamportPhoneCertification } from '@modules/Iamport/Certification/F/fs.js';
import { initIamport } from '@modules/Shopify/Payment/F/service.js';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF.js';
import { MShopAppAdultForeignerF } from '@modules/MShop/App/Adult/Foreigner/F/Function/module/MShopAppAdultForeignerF.js';
import { changeLang } from '@modules/MShop/App/Adult/S/Tmpl/adult.js';
import { makeEmptyScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { Confirm } from '@services/MarppleShop/renderApp/components/cells/Confirm/Confirm.ts';
import { Alert } from '@services/MarppleShop/renderApp/components/cells/Alert/Alert.ts';
import { makeMainUrl } from '@services/MarppleShop/shared/util/url.ts';

const back = (plus_crew, is_app, length = 1) => {
  if (plus_crew) {
    if (is_app) {
      return MShopUtilF.postMessage({
        goBack: true,
      });
    }

    if (document.referrer && window.history.length > length) {
      history.back();
    } else {
      location.href = makeMainUrl(`/${ET.lang}`);
    }
  }
};

const is_app = MShopUtilF.isApp();

const checkKr = async () => {
  await initIamport();
  const { data: result } = await iamportPhoneCertification((imp_uid) =>
    axios.post(`/${T.lang}/@api/check_users_adult`, {
      imp_uid,
    }),
  );
  return result;
};

export const check = async ({ plus_crew, seller }) => {
  const confirmed = Confirm.open({
    title: ET('mps2::adult::need_verify'),
    message: html`<div>
      <div>${html.preventEscape(T('mshop::성인 인증이 필요합니다.인증을 진행하시겠습니까?'))}</div>
      ${html.preventEscape(changeLang(location.href, T.lang))}
    </div>`,
    confirmText: ET('mps2::adult::go_verify'),
  });

  if ($1('html[is_mobile="false"][lang="en"]')) {
    $.css($1('#don_confirm .content'), { width: 'auto', display: 'inline-block' });
  }

  const confirm = await confirmed;
  if (!confirm) {
    return back(plus_crew, is_app);
  }

  const redirect_url = plus_crew ? `${location.origin}/${T.lang}` : `${location.origin}${location.pathname}`;

  if (!box.sel('is_user')?.id) {
    return is_app
      ? MShopUtilF.postMessage(
          makeEmptyScreenNavigate(
            `${location.origin}/${T.lang}/login?url=${encodeURIComponent(redirect_url)}`,
          ),
        )
      : (location.href = `/${T.lang}/login?url=${redirect_url}`);
  }

  MShopUtilF.bodyFixed$(true);

  try {
    const result = T.lang == 'kr' ? await checkKr() : await MShopAppAdultForeignerF.check();
    if (result) {
      if (is_app) {
        return MShopUtilF.postMessage({
          replaceNavigate: {
            type: 'util',
            ...(plus_crew
              ? { title: plus_crew?.name || '', titleImage: plus_crew?.mo_main_logo || '' }
              : { title: seller?.name?.trim() || '', titleImage: seller.logo_img }),
            uri: redirect_url,
          },
        });
      } else {
        return window.location.reload();
      }
    } else {
      await Alert.open({
        title: T('mshop::Access Denied'),
        message: html.preventEscape(T('mshop::Users must be at least 18 to access age-restricted contents.')),
        confirmText: T('mshop::Return'),
      });
    }
  } catch (e) {
    if (e.response?.data?.message) {
      await Alert.open({ title: e.response?.data?.message });
    } else {
      await Alert.open({
        title: ET('mps2::adult::verify_cancel'),
        message: html.preventEscape(ET('mps2::adult::verify_cancel_description')),
      });
    }
  }
  MShopUtilF.bodyFixed$(false);
  return back(plus_crew, is_app, 3);
};
